export const config: any = {
    general: {
        quantity: {
            min: 1,
            max: 999
        },
        currency: {
            code: "EUR",
            symbol: "€",
            position: "after"
        },
        decimals: 2,
        roundingPrecision: 2,
        tax: {
            displayMode: "include",
            default: "standard",
            rates: {
                standard: 1.21
            },
            suffix: {
                visible: false,
                labels: {
                    include: "(incl. tax)",
                    exclude: "(excl. tax)"
                }
            }
        }
    },
    links: {
        cart: {
            label: "Cart",
            url: "/cart"
        },
        checkout: {
            label: "Checkout",
            url: "/checkout"
        },
        shop: {
            label: "Go to shop",
            url: "/shop"
        }
    }
}

export const theme: any = {
    general: {
        sizingBase: 16,
        animations: true, // TODO
        transition: {
            duration: "400ms",
            timingFunction: "ease-in-out" 
        },
        mobileBreakpoint: 1024 
    }, 
    icons: {},
    components: {
        cartButton: {
            maxHeight: 4,
            background: "#f00000",
            borderWidth: 0,
            borderColor: 'transparent',
            borderRadius: 0,
        },
        cartButtonIcon: {
            image: 'default', 
            position: 'left',
            fill: '#ffffff'
        },
        cartButtonSubotal: {
            textColor: '#ffffff'
        },
        sidebar: { 
            header: {
                background: '#1d1d1b'
            },
            content: {
                background: '#1d1d1b'
            },
            footer: {
                background: '#1d1d1b'
            },
            overlay: {
    
            },
        },
        cartItem: {
            image: {
                size: 4,
                borderRadius: 2,
            },
            name: {
                textColor: '#ffffff',
            },
            attributes: {
                textColor: '#dddddd',
            },
            quantity: { 
                maxWidth: 5, 
                textColor: "#333",
                background: "transparent",
                borderWidth: 0.1,
                borderRadius: 0.0,
                borderColor: "#ddd",
                buttonTextColor: "#333",
                buttonBackground: "transparent",
                hoverButtonTextColor: "#fff",
                hoverButtonBackground: "#000", 
                borderColorHover: "#000"
            },  
            pricePerUnit: {
                textColor: '#dddddd',
                textSize: 3
            },
            subtotal: {
                textColor: '#1d1d1b',
                textSize: 4
            }
        }
    }
};

export const translations: any = { 
    cartHeader: {
        title: "Cart"
    },
    cartFooter: {
        subtotal: "Subtotal"
    },
    cartEmpty: {
        title: "I feel so empty...",
        subtitle: "What about filling me with some good stuff, huh?",
    }
}